import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { meetsLevel, withUser } from "@/helpers/user";
import { sortBy } from "lodash";
import { LANDSCAPE_DEFAULTS, LANDSCAPE_DEFAULT_URL } from "@/helpers/defaults";
import Landscape from "./landscape/landscape";
import TitleBox from "./landscape/title-box";

const { filters: DEFAULT_FILTERS_MAP, fields: DEFAULT_FIELDS_MAP, venn: DEFAULT_VENN_MAP, docsUrl: DOCS_URL, versionsPublic } = LANDSCAPE_DEFAULTS.genai;
const VERSIONS = sortBy(Object.keys(DEFAULT_FILTERS_MAP));

const GenAILandscape = ({ user, params, router }) => {
  const accessLevel = user?.accessLevel?.landscapeGenai;
  const exportLevel = user?.accessLevel?.landscapeExport;
  const isAdmin = meetsLevel(user?.accessLevel?.app, "admin");
  const { version } = params;
  const versionsAllowed = isAdmin ? VERSIONS : versionsPublic;
  const title = (
    <TitleBox
      standards={["genai"]}
      standardCurrent="genai"
      onStandardChange={val => router.push({ pathname: `/standards/opal/${val}` })}
      text="GenAI"
      methodologyLink={DOCS_URL}
      versionHidden={true}
      currentVersion={version}
      versionOptions={versionsAllowed}
      versionDisabled={!meetsLevel(accessLevel, "full")}
      onVersionChange={val => router.push({ pathname: `/standards/opal/genai/${val}`, query: DEFAULT_FILTERS_MAP[val] })}
    />
  );
  return (
    <Fragment>
      <Helmet
        title="GenAI Landscape"
        meta={[
          { name: "keywords", content: "patent landscape, standard essential patent, SEP, royalty rate, RAND, FRAND, LTE, 3GPP, SISVEL, VIA" },
          { name: "description", content: "The only GenAI SEP patent landscape that uses objective measures to train a semantic algorithm." }
        ]}
      />
      <Landscape
        accessLevel={accessLevel}
        exportLevel={exportLevel}
        title={title}
        esUrl={LANDSCAPE_DEFAULT_URL}
        version={DEFAULT_FIELDS_MAP[version]}
        defaultFilters={DEFAULT_FILTERS_MAP[version]}
        defaultVenn={DEFAULT_VENN_MAP[version]}
        key={version}
        hiddenFilters={["3gpp", "pools"]}
      />
    </Fragment>
  );
};

export default withUser(GenAILandscape);
